const DEFINITIONS = [

  //3 letras

  {
    word: 'opa',
    definition: 'Sinonimo de tonto.',
    example:
    'Eh pero sos opa chango no?',
  }, 
  {
    word: 'fli',
    definition: 'Insecticida de bajo costo.',
    example:
    'Echa fli en la pieza que está lleno de sancudos.',
  }, 
  {
    word: 'ite',
    definition: 'Vete.',
    example:
    'Ite ya, meta.',
  }, 
  {
    word: 'tuy',
    definition: 'Sinónimo de caliente o me quemé.',
    example:
    'Tuy! esto ta que pela.',
  }, 
  {
    word: 'aca',
    definition: 'Palabra comodín, sinónimo de excremento.',
    example:
    'No hay ni aca pa comé.',
  }, 

  //4 letras

  {
    word: 'anco',
    definition: 'Sinónimo de cabeza.',
    example:
    'Chango me duele el anco, no voy a salir.',
  },
  {
    word: 'mave',
    definition: 'Expresión cuyo significado es: ¿A ver?.',
    example:
    'Mave mostrame que compraste.',
  },
  {
    word: 'tuto',
    definition: 'Sinonimo de caliente, expresion utilizada para los bebés.',
    example:
    'Esto está tuto.',
  },
  {
    word: 'mear',
    definition: 'Sinonimo de orinar.',
    example:
    'Chango ya vuelvo me voy a mear.',
  },
  {
    word: 'yuta',
    definition: 'No ingresar al establecimiento escolar.',
    example:
    'Eh vieja, se hagamo la yuta.',
  },
  {
    word: 'sosa',
    definition: 'Mercerdes Sosa, cantante tucumana.',
    example:
    '',
  },

  {
    word: 'jeta',
    definition: 'Sinónimo de boca.',
    example:
    'Mirala a esa, toda la jeta pintada anda.',
  }, 
  {
    word: 'chuy',
    definition: 'Expresión de frio.',
    example:
    'Chuy, ta helao.',
  }, 
  {
    word: 'vaga',
    definition: 'Señorita.',
    example:
    'Ta fuerte la vaga.',
  }, 
  {
    word: 'pava',
    definition: 'Sinónimo de fácil.',
    example:
    'Ale sos bien pava en el fifa.',
  }, 
  {
    word: 'vivo',
    definition: 'Sinónimo de pícaro.',
    example:
    'Ese se está colando, se hace el vivo.',
  }, 
  {
    word: 'hoyo',
    definition: 'Sinónimo de suerte.',
    example:
    'Ese tiene mas hoyo que espalda queno ganó la quiniela.',
  }, 

  //5 letras

  {
    word: 'chivo',
    definition: 'Persona masculina que sufrió una infidelidad.',
    example: 'Viste que al de la esquina lo han hecho chivo?',
  },
  {
    word: 'sonsa',
    definition: 'Persona de sexo feminino "tonta" o "torpe"',
    example: 'te dije que te iba a gorriar, vei que so sonsa vo?',
  },
  {
    word: 'chiva',
    definition: 'Persona del sexo femenino que sufrió una infidelidad.',
    example:
    'Changa date cuenta, sos semejante chiva.',
  },
  {
    word: 'ramia',
    definition: 'Expresion cuyo sinonimo es arrastrar.',
    example:
    'Llegas a desaprobar y te voy a ramia de las mechas.',
  },
  // {
  //   word: 'choto',
  //   definition: 'Expresion comodin, mas relacionadad con el miembro masculino.',
  //   example:
  //   'Nada me sale bien, me cago en el choto',
  // },
  {
    word: 'papia',
    definition: 'Comer.',
    example:
    '¡Ya está la comida, vengan a papiar!',
  },
  {
    word: 'bollo',
    definition: 'golpe de puño.',
    example:
    'Portate bien porque te estás ganando un bollo',
  },
  {
    word: 'paila',
    definition:
    'Persona con orejas grandes.',
    example:
    'Vea esas semejantes pailas que tiene.',
  },
  {
    word: 'apuna',
    definition: 'Malestar en el oído por la altura.',
    example:
    'Iba subiendo a Tafí Del Valle y me a dió la apuna.',
  },
  {
    word: 'chuño',
    definition: 'sinónimo de vómito.',
    example:
    'Vea ese chuño que pegó el Nico.',
  },
  {
    word: 'fiero',
    definition: 'Persona de poco atractivo visual, sinónimo de feo.',
    example:
    'So ma fiero que el pingo.',
  },
  {
    word: 'croto',
    definition: 'Persona desarreglada.',
    example:
    'Anda ponete unas zapatillas, andás bien croto.',
  },
  {
    word: 'macho',
    definition: 'Tercera persona de una relación amorosa, sinónimo de amante.',
    example:
    'A la Maria le han dao la cana con el macho.',
  },
  {
    word: 'tacho',
    definition: 'Contenedor de basura, tambien utilizado para nombrar al valde o cubeta.',
    example:
    'Andá tirá la basura en el tacho',
  },
  {
    word: 'choro',
    definition: 'Ladrón.',
    example:
    'Lo han pillao al choro en la esquina, vamo a ve quien es.',
  },
  {
    word: 'sonso',
    definition: 'Persona de sexo masculino "tonto" o "torpe"',
    example:
    'Chango como vas a pisar aca, ¿Vei que so sonso?',
  },
  {
    word: 'ladia',
    definition: 'De lado o de costado.',
    example:
    'Venía en la moto y se me la ladiao, casi me caigo.',
  },
  {
    word: 'ocote',
    definition: 'Expresión vulgar para nombrar a la cola.',
    example:
    'Vea ese semejante ocote que tenes para aprobar con 6.',
  },
  {
    word: 'jaldo',
    definition: ' Osvaldo Francisco Jaldo, actual gobernador de la provincia de Tucumán',
    example:
    '',
  },
  // {
  //   word: 'ortia',
  //   definition: 'Expresion vulgar de cuando te tocan la cola.',
  //   example:
  //   'Eh dejen de ortia eh, no sean abusos.',
  // },
  {
    word: 'pilla',
    definition: 'Expresion con 2 siginificados proviene de atrapar, y de persona dificil de engañanar.',
    example:
    'El choro se dejó pillá por la polecia.',
  },
  {
    word: 'chaja',
    definition: 'Expresion utilizada para el amigo que le gusta mirar a las mujeres de sus amigos.',
    example:
    'Chango como te vas a levantar a la ex de tu mejor amigo, so alto chajá vo.',
  },
  {
    word: 'julio',
    definition:
    'Julio Argentino Roca, ex presidente de la nación, histórico personaje ilustre de Tucumán.',
    example:
    '',
  },
  {
    word: 'juira',
    definition: 'Expresión para que se vaya alguien.',
    example:
    'Juira perro!',
  },
  {
    word: 'lules',
    definition: 'Departamento de Tucumán.',
    example:
    'Ahí en Lules hay semajantes minitas.',
  },
  {
    word: 'pingo',
    definition: 'Expresion comodin, mas relacionada con el miembro masculino.',
    example:
    'Me cago en el pingo, Que calor del pingo.',
  },
  {
    word: 'ydiai',
    definition: 'Expresión tucumana derivada de "¿Y de ahí?", utilizada para decir "¿Y ahora?" con tono de sorpresa, drama o puro chusmerío. Existen múltiples variantes creativas: idiai, ideai, ydiay, Ydiai.',
    example:
      'ydiai, que ya venís?',
  },
  {
    word: 'comue',
    definition: 'Expresion utilizada para decir ¿COMO ES?.',
    example:
    'Pasame la comué que está ahí.',
  },
  {
    word: 'pirao',
    definition: 'palabra con multiple significado "Loco" o "Se escapó"',
    example: 'Estaba sacando un dorao y se me lo a pirao chango podes creer.',
  },
  {
    word: 'vacia',
    definition: 'Expresion utilizada para decir TOMEMOS ALCOHOL.',
    example:
    'Escucha ese temaaaa, VACIAAAAAA.',
  },
  {
    word: 'crios',
    definition: 'Niños.',
    example:
    'El otro dia mi hermana me a dejao con los crios, son unos demonios.',
  },
  // {
  //   word: 'afana',
  //   definition: 'Sinónimo de robo.',
  //   example:
  //   'A la salida del boliche me han afanao el celu.',
  // },
  {
    word: 'bulla',
    definition: 'Ruido.',
    example:
    '¡Dejen de hacer bulla que está durmiendo el abuelo!',
  },
  {
    word: 'churo',
    definition: 'Gracioso, amigable.',
    example:
    'De churo que so vo jaja.',
  },
  {
    word: 'yambe',
    definition:'Abreviatura de "Ya vamos a ver"',
    example:
    'Yambe que hacemo mas tarde.',
  },
  {
    word: 'mishi',
    definition: 'Gato.',
    example:
    'Sacalo al mishi de la mesa!',
  },
  {
    word: 'patia',
    definition:
    'Expresion utilizada proveniente del verbo PATEAR.',
    example:
    'Patiá po fuerte Guillermo, que queri coloca.',
  },
  // {
  //   word: 'pucho',
  //   definition: 'Cigarrillo.',
  //   example:
  //     'Convidame un pucho, no seas aca.',
  // },
  {
    word: 'pecha',
    definition: 'Empujar.',
    example:
      'Eh dejen de pechá, si vamos a pasar todos.',
  },
  {
    word: 'putia',
    definition:
      'Sinónimo de insultar.',
    example:
      'El borracho en la plaza me estaba meta putiá porque no le di plata pal vino.',
  },
  {
    word: 'toria',
    definition: 'Ladrido de los perros.',
    example:
      'Pancho levantate a ver que estan meta toriá los perros.',
  },
  {
    word: 'upiti',
    definition: 'Persona entrometida.',
    example:
      'Ve por upiti a vos tambien te han estafao.',
  },
  {
    word: 'honda',
    definition: 'Arma casera utilizada para cazar, sinónimo de GOMERA.',
    example:
      'Vamo a hondiá unas palomas.',
  },
  {
    word: 'giria',
    definition: 'Escupir a alguien.',
    example:
      'Estos estan meta giriá, parecen guanacos.',
  },
  {
    word: 'tordo',
    definition: 'Sinónimo de amante.',
    example:
      'Pobre Raúl, la Karen salió con el tordo ayer cuando él estaba trabajando.',
  },
  {
    word: 'lance',
    definition: 'Sinónimo de oportunidad',
    example:
      'No estudié pero me tire un lance.',
  },
  {
    word: 'urgar',
    definition: 'Meter mano en algo sin tener idea al respecto.',
    example:
      'Luciano deja de urgar ese celular!.',
  },
  {
    word: 'queno',
    definition: 'Palabra utilizada para afirmar o asegurar algo.',
    example:
      'Layla está pa una vaciada quenó? ',
  },
  {
    word: 'yagui',
    definition: 'Término abreviado que denota la inminente intención de dirigirse a un lugar: "Ya voy a ir"',
    example:
      '- Anda a compra una mirinda manzana, - Yaguí',
  },
  {
    word: 'tarro',
    definition: 'Palabra con múltiples significados. Puede ser suerte o un recipiente.',
    example:
      'Aprobé historia con 6, tuve semejante tarro.',
  },

    {
    word: 'uñudo',
    definition: 'Puntín al patear la pelota.',
    example:
      'Iba fuerte la pelota con el uñudo que le dí.',
  },

  //6 letras

  {
    word: 'pavura',
    definition: 'Sinónimo de vergüenza.',
    example:
      'Me hicieron pasar a exponer, alta pavura tenía.',
  },
  {
    word: 'felipe',
    definition: 'Niño viral tucumano, conocido por mover los hombritos.',
    example:
      'Usted amiguito mira como mueve los hombritos.',
  },
  {
    word: 'cabudo',
    definition: 'Se dice de la persona que tiene el pelo muy duro, grueso y áspero, parecido a un alambre.',
    example:
      'Ese chango es bien cabudo, ni el parece limon de cumpleaños.',
  },
  {
    word: 'chango',
    definition: 'Persona de sexo masculino, joven',
    example:
      'Vamo a come un sangui chango!.',
  },
  {
    word: 'ciruja',
    definition: 'Simpatizante del club San Martín de Tucumán.',
    example:
      'Vamo lo ciruja papaaaaa.',
  },
  {
    word: 'changa',
    definition: 'Persona de sexo femenino, joven',
    example:
      'Vamo a baila changa!.',
  },
  {
    word: 'machao',
    definition: 'Persona en estado de ebriedad.',
    example:
      'Miralo a ese, anda bien machao.',
  },
  {
    word: 'filito',
    definition: 'Payaso tucumano reconocido por la canción de los hombritos.',
    example:
      'Usted amiguito, mira como mueve los hombritos.',
  },
  {
    word: 'ancazo',
    definition: 'Sinónimo de cabezazo.',
    example:
      'Chango estaba viendo el partido, que ancazo se dieron queno.',
  },
  {
    word: 'caschi',
    definition: 'Canino de raza indefinida.',
    example:
      'Anda fijate que está meta toria el caschi',
  },
  {
    word: 'decano',
    definition: 'Simpatizante del club Atletico Tucumán.',
    example:
      'Vamo lo decaaaa.',
  },
  {
    word: 'hoyudo',
    definition: 'Afortunado, suertudo.',
    example:
      'Gané $120.000 en la quiniela, ando bien hoyudo.',
  },
  {
    word: 'pupulo',
    definition: 'Sinónimo de satisfecho, lleno.',
    example:
      'Comí tanto locro que estoy pupulo.',
  },
  {
    word: 'turulo',
    definition: 'Sinónimo de tonto.',
    example:
      'Chango pero sos bien turulo.',
  },
  {
    word: 'mamila',
    definition: 'Sinónimo de cobarde.',
    example:
      'Chango encarala, no seas mamila.',
  },
  {
    word: 'sangui',
    definition: 'Palabra tucumanizada cuyo significado es Sandwich.',
    example:
      'Chango está pa comé un sangüi con mirinda manzana queno.',
  },


  //7 letras
  {
    word: 'bandiao',
    definition: 'Extralimitarse, pasarse de la raya.',
    example:
      'Eh chango estan bandiao como van a tirar la pelota al agua.',
  },
  {
    word: 'antarca',
    definition: 'Sinónimo de espalda.',
    example:
      'Chango estaba la vieja sentada y se cayó de antarca.',
  },
  {
    word: 'aporria',
    definition: 'Sinónimo de golpear, pegar.',
    example:
      'Volá de aqui porque te voy a aporria.',
  },
  {
    word: 'apretao',
    definition: 'Sandwich de fiambre. Normalmente de Mortadela y queso.',
    example:
      'Le apliquemo un apretao a la salida de la facu.',
  },
  {
    word: 'tincazo',
    definition: 'Golpe realizado al flexionar el dedo medio (dedo mayor) contra el pulgar.',
    example:
      'Eh chango como ve vas a pega semejante tincazo.',
  },
  {
    word: 'empacho',
    definition: 'Sinónimo de indigestión, problemas estomacales.',
    example:
      'Me voy a doña pocha para que me cure el empacho.',
  },
  {
    word: 'bambaco',
    definition: 'Sinónimo de tonto.',
    example:
      'Como vas a mete la pata en el agua, sos semejante bambaco.',
  },

  //8 letras
  {
    word: 'achilata',
    definition: 'Helado tucumano a base de hielo y colorantes.',
    example:
      'Con el calor ta pa aplicale una achilata queno.',
  },
  {
    word: 'empingue',
    definition: 'Sinónimo de aburrido, embolado.',
    example:
      'Tengo un empingue, no hay nada para hacer.',
  },
  {
    word: 'turucuto',
    definition: 'Sinónimo de caballito o cococho.',
    example:
      'Se desmayó la tia pocha y la tuve que llevar a turucuto.',
  },
  {
    word: 'volantin',
    definition: 'Barrilete, cometa.',
    example:
      'Hagamo volar el volantin.',
  },
  //9 letras
  {
    word: 'panchuque',
    definition: 'Aperitivo de comida rápida típico de Tucuman elaborado con masa y salchicha.',
    example:
      'Ta pa aplicale un panchuque queno.',
  },
  {
    word: 'alfiñique',
    definition: 'Golosina autóctona de la provincia elaborada a base de miel de caña de azucar.',
    example:
      'Mijo tome un alfiñique... atte: la abu.',
  },
  {
    word: 'entrefino',
    definition: 'Fideo económico de grosor indefinido de uso guisero.',
    example:
      'Está pa un guisito de entrefino queno.',
  },
]

let WORDS = []

DEFINITIONS.forEach(function (item, index) {
  WORDS.push(item.word)
})

export { WORDS, DEFINITIONS }